var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgP = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "5.25rem",
  height: "5.25rem",
  "data-name": "Group 34",
  viewBox: "0 0 200 200.006"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "P_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h200v200.006H0z",
  "data-name": "Rectangle 31",
  style: {
    fill: "none"
  }
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33",
  style: {
    clipPath: "url(#P_svg__a)"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M100 197.506a97.5 97.5 0 0 1-96.762-85.629 96 96 0 0 1-.732-11.865 97.5 97.5 0 0 1 194.989-.812v.814A97.605 97.605 0 0 1 100 197.506m0-129.576a32.33 32.33 0 0 0-28.738 17.889 30.9 30.9 0 0 0-3.344 14.193 32.051 32.051 0 0 0 63.179 7.663 30.7 30.7 0 0 0 .985-7.663A32.12 32.12 0 0 0 100 67.93",
  "data-name": "Path 85",
  style: {
    fill: "#fff"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M100 5.017a94.953 94.953 0 0 1 94.994 94.161v.833A94.99 94.99 0 0 1 5.717 111.557a94.91 94.91 0 0 1 27.1-78.725A94.38 94.38 0 0 1 100 5.017M69.035 84.682a33.4 33.4 0 0 0-3.617 15.329 34.55 34.55 0 0 0 68.1 8.291 33.3 33.3 0 0 0 1.064-8.291 34.561 34.561 0 0 0-65.547-15.329M100 .017A99.967 99.967 0 0 0 .006 100.011a98 98 0 0 0 .75 12.167 99.99 99.99 0 0 0 199.238-12.167v-.833A99.95 99.95 0 0 0 100 .017m0 129.576a29.59 29.59 0 0 1-29.582-29.582A28.56 28.56 0 0 1 73.5 86.929a29.561 29.561 0 0 1 56.079 13.082 28.5 28.5 0 0 1-.916 7.083A29.43 29.43 0 0 1 100 129.593",
  "data-name": "Path 86"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M133.536 5.775a85.5 85.5 0 0 0-13.475-3.749A100.5 100.5 0 0 0 100 0c-1.419 0-2.736 0-4.154.1A99.985 99.985 0 0 0 0 100c0 4.052.3 8.105.709 12.158a34.7 34.7 0 0 0 13.881 7.7c8 2.229 17.325 1.115 23.708-4.154 7.6-6.485 9.828-17.224 15.7-25.228a18.7 18.7 0 0 1 8.207-6.687c3.444-1.115 7.5-.71 10.132 1.823a6.4 6.4 0 0 1 1.114 1.318A29.587 29.587 0 0 1 129.585 100a27.2 27.2 0 0 1-.912 7.092c7.5-3.445 14.893-10.639 22.695-8.106 6.282 2.027 8.916 9.322 10.638 15.705 1.216 4.762 2.533 9.422 3.85 13.981 1.115 4.053 2.938 8.815 6.383 10.538a5.35 5.35 0 0 0 2.533.81c3.04.3 6.079-1.824 7.6-4.661 1.621-2.634 2.128-5.876 2.634-8.916 1.013-6.078 2.027-12.056 2.938-18.034.405-2.735 1.014-5.775 3.04-7.6 2.229-1.925 5.167-1.925 8.308-1.621H200a99.9 99.9 0 0 0-66.464-93.413",
  "data-name": "Path 87"
})), /*#__PURE__*/React.createElement("path", {
  d: "M34.257 53.114a3.125 3.125 0 0 1-2.173-5.371L43.892 36.33a3.125 3.125 0 1 1 4.345 4.492L36.43 52.235a3.13 3.13 0 0 1-2.173.879",
  "data-name": "Path 88",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.912 32.555a3 3 0 0 1-.846-.118L111.254 28a3.124 3.124 0 1 1 1.693-6.014l15.811 4.439a3.124 3.124 0 0 1-.846 6.132",
  "data-name": "Path 89",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 89.277a3.125 3.125 0 0 1-1.782-5.692l13.5-9.35a3.125 3.125 0 1 1 3.564 5.135l-13.5 9.35a3.1 3.1 0 0 1-1.782.557",
  "data-name": "Path 90",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.074 63.9a3.1 3.1 0 0 1-1.587-.431l-14.143-8.336a3.127 3.127 0 1 1 3.174-5.388l14.143 8.338a3.124 3.124 0 0 1-1.587 5.817",
  "data-name": "Path 91",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M160.934 86.161a3 3 0 0 1-.618-.061 3.123 3.123 0 0 1-2.442-3.686l3.272-16.092a3.122 3.122 0 1 1 6.119 1.245l-3.271 16.092a3.125 3.125 0 0 1-3.06 2.5",
  "data-name": "Path 92",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.366 61.162a3 3 0 0 1-.618-.061 3.12 3.12 0 0 1-2.442-3.686l3.272-16.092a3.122 3.122 0 1 1 6.122 1.245L76.426 58.66a3.125 3.125 0 0 1-3.06 2.5",
  "data-name": "Path 93",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.4 24.511a3.14 3.14 0 0 1-1.693-.5l-13.821-8.874a3.126 3.126 0 0 1 3.385-5.257l13.818 8.878a3.126 3.126 0 0 1-1.689 5.753",
  "data-name": "Path 94",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M153.2 44.452a3.126 3.126 0 0 1-1.05-6.071l15.478-5.5a3.127 3.127 0 0 1 2.1 5.892l-15.477 5.5a3.2 3.2 0 0 1-1.05.179",
  "data-name": "Path 95",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.53 91.853a3 3 0 0 1-.977-.159l-15.591-5.151a3.123 3.123 0 1 1 1.953-5.932l15.592 5.151a3.123 3.123 0 0 1-.977 6.091",
  "data-name": "Path 96",
  style: {
    fill: "#fff"
  }
})));
export default SvgP;